// MyProjectsModal — список моих CAD-проектов в облаке.
//
// Используется когда юзер выбирает «Файл → Открыть из облака» (Месяц 9 плана).
// Показывает все его проекты отсортированные по updated_at desc.
// Действия: открыть (двойной клик / кнопка), удалить (контекстное меню).

import React, { useEffect, useState } from 'react';
import { listMyProjects, openFromCloud, deleteCloudProject } from '../cloudIO';
import cl from './MyProjectsModal.module.css';


const MyProjectsModal = ({ onClose, onOpened }) => {
    const [items, setItems]   = useState([]);
    const [loading, setLoad]  = useState(true);
    const [error, setError]   = useState(null);
    const [busyId, setBusyId] = useState(null);

    useEffect(() => {
        let alive = true;
        (async () => {
            try {
                setLoad(true);
                const list = await listMyProjects();
                if (alive) setItems(list);
            } catch (e) {
                if (alive) setError(e.message || String(e));
            } finally {
                if (alive) setLoad(false);
            }
        })();
        return () => { alive = false; };
    }, []);

    const onOpen = async (id) => {
        setBusyId(id);
        try {
            await openFromCloud(id);
            onOpened?.();
            onClose();
        } catch (e) {
            alert('Ошибка открытия: ' + (e.message || e));
        } finally {
            setBusyId(null);
        }
    };

    const onDelete = async (id, title) => {
        if (!window.confirm(`Удалить «${title}» из облака? Это действие нельзя отменить.`)) return;
        setBusyId(id);
        try {
            await deleteCloudProject(id);
            setItems((prev) => prev.filter((p) => p.id !== id));
        } catch (e) {
            alert('Ошибка удаления: ' + (e.message || e));
        } finally {
            setBusyId(null);
        }
    };

    return (
        <div className={cl.backdrop} onClick={onClose}>
            <div className={cl.modal} onClick={(e) => e.stopPropagation()}>
                <div className={cl.header}>
                    <h3 className={cl.title}>📂 Мои проекты в облаке</h3>
                    <button className={cl.closeBtn} onClick={onClose}>✕</button>
                </div>

                <div className={cl.body}>
                    {loading && <div className={cl.muted}>Загрузка…</div>}
                    {error && <div className={cl.error}>⚠ {error}</div>}
                    {!loading && !error && items.length === 0 && (
                        <div className={cl.empty}>
                            Пока нет ни одного проекта.<br/>
                            Сохрани документ через «Файл → Сохранить в облако».
                        </div>
                    )}
                    {items.map((p) => (
                        <div
                            key={p.id}
                            className={`${cl.row} ${busyId === p.id ? cl.rowBusy : ''}`}
                            onDoubleClick={() => onOpen(p.id)}
                        >
                            <div className={cl.rowMain}>
                                <div className={cl.rowTitle}>{p.title || 'Без названия'}</div>
                                <div className={cl.rowSub}>
                                    Обновлён: {p.updated_at || '—'}
                                </div>
                            </div>
                            <div className={cl.rowActions}>
                                <button
                                    className={cl.openBtn}
                                    disabled={busyId === p.id}
                                    onClick={() => onOpen(p.id)}
                                >
                                    Открыть
                                </button>
                                <button
                                    className={cl.delBtn}
                                    disabled={busyId === p.id}
                                    onClick={() => onDelete(p.id, p.title)}
                                    title="Удалить"
                                >
                                    🗑
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MyProjectsModal;
